import React, { useEffect, useMemo, useState } from "react";
import { getData, getUserId } from "../../../../../Utils/Common/Library";
import { Typography } from "@mui/material";
import { WorkflowProcesser } from "../../WorkflowProcesser";
import AssessmentForm from "./AssessmentForm";

function AssessmentModal({
  AssessmentData,
  AssessmentPeriod,
  TargetDataType,
  AchievementDataType,
  onChangeAssessment,
  TargetRule,
  handleTabEdit,
  RatingScaleID,
  ParameterWeightage,
  Workflow,
  actorAssessmentForParams,
  Achievements,
}) {
  if (ParameterWeightage === "%") ParameterWeightage = null;
  if (!actorAssessmentForParams) actorAssessmentForParams = [];

  const userId = getUserId();
  const [loading, setLoading] = useState(false);
  const [scale, setScale] = useState(null);

  const workflowProcesser = new WorkflowProcesser(Workflow);
  const WorkflowStep = workflowProcesser.getCurrentStep(); //returns index of step
  const CurrentUserStep = workflowProcesser.getStepByIndex(WorkflowStep);
  const viewerIndex = workflowProcesser.getStepOfLoggedInUser(userId); //index of step
  const ViewerStep = workflowProcesser.getStepByIndex(viewerIndex);

  const { StepOwnerLabel } = CurrentUserStep || {};

  let message = "";
  let edit = [false, false]; // 0 index is for appraisee and 1 index is for appraiser
  let view = [false, false]; // 0 index is for appraisee and 1 index is for appraiser

  const isModeratorDone = (Workflow?.WorkflowSteps || []).find(
    (w) =>
      w.StepOwnerLabel === "Moderator" &&
      w.StepType === "Actioned" &&
      w.StepAction === "Confirm"
  );

  const isAppraiseeSelfAssessment = useMemo(() => {
    const appraiseeSteps = (Workflow?.WorkflowSteps || []).filter(
      (w) => w.StepOwnerLabel === "Appraisee"
    );
    if (!appraiseeSteps) return false;
    const appraiseeSubmitStep = appraiseeSteps.find((s) =>
      (s?.AllowedActions || []).includes("Submit")
    );
    if (appraiseeSubmitStep) return true;
    return false;
  }, [Workflow?.WorkflowSteps]);

  const ViewerLabel = ViewerStep?.StepOwnerLabel;

  if (!ViewerLabel) {
    edit = [isAppraiseeSelfAssessment ? true : false, false];
    view = [false, false];
  } else if (workflowProcesser.getWorkflowStatus() === "C") {
    view = [isAppraiseeSelfAssessment ? true : false, true];
    edit = [false, false];
  } else {
    if (StepOwnerLabel === "Appraisee") {
      if (ViewerLabel === "Appraisee") {
        view = [
          isAppraiseeSelfAssessment ? true : false,
          isModeratorDone ? true : false,
        ];
        edit = [
          isModeratorDone ? false : isAppraiseeSelfAssessment ? true : false,
          false,
        ];
      }
      if (ViewerLabel === "Appraiser") {
        view = [
          isAppraiseeSelfAssessment ? true : false,
          isModeratorDone ? true : false,
        ];
        edit = [false, false];
      }
      if (ViewerLabel === "Reviewer") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
      if (ViewerLabel === "Moderator") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
    }
    if (StepOwnerLabel === "Appraiser") {
      if (ViewerLabel === "Appraisee") {
        view = [
          isAppraiseeSelfAssessment ? true : false,
          isModeratorDone ? true : false,
        ];
        edit = [false, false];
      }
      if (ViewerLabel === "Appraiser") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, isModeratorDone ? false : true];
      }
      if (ViewerLabel === "Reviewer") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
      if (ViewerLabel === "Moderator") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
    }
    if (StepOwnerLabel === "Reviewer") {
      if (ViewerLabel === "Appraisee") {
        view = [
          isAppraiseeSelfAssessment ? true : false,
          isModeratorDone ? true : false,
        ];
        edit = [false, false];
      }
      if (ViewerLabel === "Appraiser") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
      if (ViewerLabel === "Reviewer") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
      if (ViewerLabel === "Moderator") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
    }
    if (StepOwnerLabel === "Moderator") {
      if (ViewerLabel === "Appraisee") {
        view = [isAppraiseeSelfAssessment ? true : false, false];
        edit = [false, false];
      }
      if (ViewerLabel === "Appraiser") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
      if (ViewerLabel === "Reviewer") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
      if (ViewerLabel === "Moderator") {
        view = [isAppraiseeSelfAssessment ? true : false, true];
        edit = [false, false];
      }
    }
  }

  AssessmentData[0].view = view[0];
  AssessmentData[1].view = view[1];
  AssessmentData[2].view = false;

  AssessmentData[0].disable = !edit[0];
  AssessmentData[1].disable = !edit[1];
  AssessmentData[2].disable = false;

  useEffect(() => {
    if (RatingScaleID) {
      setLoading(true);
      getData({
        featureId: "19148",
        payload: { "Header.TransactionID": RatingScaleID },
      })
        .then((response) => {
          setScale(response.Data[0]);
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
    }
  }, [RatingScaleID]);

  const Targets =
    TargetRule.targetType === "FV" || TargetRule.targetType === "ER"
      ? AssessmentPeriod.SingleTarget
      : AssessmentPeriod.MultipleTargets;

  let RatingScale;
  if (
    ["FV", "ER"].includes(TargetRule.targetType) ||
    TargetRule.enabled === "D"
  ) {
    RatingScale = (scale?.ScaleValues || []).map(
      ({ OptionID, Label, Value }) => {
        return [OptionID, Label, "", Value];
      }
    );
  } else {
    RatingScale = Targets.map((target) => {
      const ScaleOption = (scale?.ScaleValues || []).find(
        (value) => value.OptionID === target.ScaleOptionID
      );
      const result = [
        ScaleOption?.OptionID,
        ScaleOption?.Label,
        TargetDataType === "ST" || TargetDataType === "LT"
          ? target.SingleValue
          : `${target.MinimumRangeValue} - ${target.MaximumRangeValue}`,
        ScaleOption.Value,
      ];
      return result;
    });
  }

  const componentList = [
    ...AssessmentData.filter((d) => d.view === true).map((assess, index) => {
      const finalAssess = {
        label: "",
        Component: AssessmentForm,
        props: {
          ...assess,
          Achievements,
          handleTabEdit,
          TargetDataType,
          onChangeAssessment,
          TargetRule,
          RatingScaleID,
          AchievementDataType,
          ParameterWeightage,
          scales: RatingScale,
          Workflow,
          actorAssessmentForParams,
          StepOwnerLabel,
        },
      };

      return finalAssess;
    }),
  ];

  const isTragetEnabled = TargetRule.enabled === "E";
  function renderTargets() {
    if (TargetRule.targetType === "FV") {
      return "Fixed Value";
    }
    return (
      <>
        {RatingScale.map((scale) => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="tinytext">{scale[1]}</Typography>
            <Typography variant="tinytext">{scale[2]}</Typography>
          </div>
        ))}
      </>
    );
  }
  return loading || !scale ? (
    <div className="Flex">Loading ...</div>
  ) : (
    <div style={{ display: "flex" }}>
      {isTragetEnabled && (
        <div style={{ width: "10em", paddingRight: "3em" }}>
          <div>
            <Typography variant="h4" sx={{ marginBottom: "0.5em" }}>
              Target
            </Typography>
            {renderTargets()}
          </div>
        </div>
      )}
      {message && <Typography>{message}</Typography>}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {componentList
          .filter(
            (component) =>
              !(
                workflowProcesser.getWorkflowStatus() === "C" &&
                (RatingScaleID
                  ? component.props.RatingScaleValueID === ""
                  : component.props.RatingValue === "")
              )
          )
          .map((component) => {
            return (
              <div style={{ width: "fit-content" }}>
                <component.Component {...component.props} />
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default AssessmentModal;
